import UAParser from 'ua-parser-js'

const uaParser = new UAParser()

const types = {
  SET_UA_INFO: 'SET_UA_INFO',
}

const state = {
  uaInfo: {},
  isAppleDevice: false,
  isMobile: false,
  isTablet: false,
}

const getters = {
  uaInfo (state) {
    return state.uaInfo
  },
  isAppleDevice (state) {
    return state.isAppleDevice
  },
  isMobile (state) {
    return state.isMobile
  },
  isMobileDevice (state) {
    return state.isMobileDevice
  },
  isTablet (state) {
    return state.isTablet
  },
}

const actions = {
  // UA 信息
  initUAResult ({ commit }) {
    const uaResult = uaParser.getResult()
    commit(types.SET_UA_INFO, uaResult)
  },
}

const mutations = {
  [types.SET_UA_INFO] (state, info) {
    state.uaInfo = info
    const deviceType = info?.device?.type
    state.isMobile = ['mobile'].includes(deviceType)
    state.isTablet = ['tablet'].includes(deviceType)
    if (info?.os?.name === 'Mac OS' && window.orientation) {
      state.isTablet = true
    }
    state.isMobileDevice = state.isMobile || state.isTablet
    state.isAppleDevice = ['ios', 'mac os'].includes((info?.os?.name || '').toLowerCase())
    // console.log(JSON.stringify(info, null, 2))
  },
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
